<div class="aya-sources" *ngIf="sources.length" [id]="'aya-sources-' + messageId">
  <p class="aya-sources-title">Sources</p>
  <div class="aya-sources-row">
    <ng-container *ngFor="let source of sources; let i = index">
      <a
        *ngIf="source.url; else staticCard"
        class="aya-source-card"
        [id]="'aya-source-' + messageId + '-' + (i + 1)"
        [href]="source.url"
        target="_blank"
        rel="noopener noreferrer"
      >
        <ng-container *ngTemplateOutlet="cardBody; context: { source: source, index: i + 1 }"></ng-container>
      </a>
      <ng-template #staticCard>
        <div class="aya-source-card" [id]="'aya-source-' + messageId + '-' + (i + 1)">
          <ng-container *ngTemplateOutlet="cardBody; context: { source: source, index: i + 1 }"></ng-container>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>

<ng-template #cardBody let-source="source" let-index="index">
  <span class="aya-source-meta">
    <span class="aya-source-badge">{{ index }}</span>
    <span class="aya-source-meta-text">{{ meta(source) }}</span>
  </span>
  <span class="aya-source-title">{{ source.title }}</span>
  <span class="aya-source-snippet" *ngIf="!source.url && source.snippet">{{ source.snippet }}</span>
</ng-template>
